import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

/** Lista todas las partidas activas (con su grupo). Usada en selects de la UI. */
export function usePartidas() {
  return useQuery({
    queryKey: ['partidas'],
    queryFn: () => cliente.partidas.listar(),
    staleTime: 5 * 60_000, // cambia poco
  });
}
